import { useKeycloak } from "@react-keycloak/web";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { Menu, MenuProps } from "antd";
import Sider from "antd/es/layout/Sider";
import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import DownArrow from "../../../assets/icons/sidebar/DownArrow";
import UpArrow from "../../../assets/icons/sidebar/UpArrow";
import MainLogo from "../../../assets/images/sheba-logo.svg";
import AllSidebarMenu from "../../../constants/AllSidebarMenu";
import BsrmSidebarMenu from "../../../constants/BsrmSidebarMenu";
import CashCollectionSidebarMenu from "../../../constants/CashCollectionSidebarMenu";
import { APP_NAME } from "../../../constants/constants";
import {
  useCheckUserBelongProjectQuery,
  useGetProjectsByUserQuery,
} from "../../../features/portal/Products/productsApi";
import { stringToArray } from "../../../utils/array";
import Image from "../../ui/Image";
// import Small_LOGO from "/favicon.png";

type MenuItem = Required<MenuProps>["items"][number];

interface SidebarItemProps {
  collapsed: boolean;
  openMenuKeys: string[];
  handleOpenMenu: (keys: string[]) => void;
  isMobile?: boolean;
}

export default function SidebarItems({
  collapsed,
  openMenuKeys,
  handleOpenMenu,
  isMobile,
}: SidebarItemProps) {
  const location = useLocation();
  const { user } = useAppSelector((state) => state.auth);
  const { role } = useAppSelector((state) => state.auth);
  const { keycloak } = useKeycloak();

  const userId = user?.data?.id;

  const { data } = useGetProjectsByUserQuery(
    userId ? { params: { userid: userId } } : skipToken
  );

  const project_Id = Number(localStorage.getItem("product_id"));

  // const matchedRole = data?.data?.find(
  //   (item: any) => item?.project?.id === project_Id
  // );

  // const { data: vendorPaymentCheckData } = useCheckUserBelongProjectQuery({
  //   params: { projectId: Number(15) },
  // });

  const { data: disbursementCheckData } = useCheckUserBelongProjectQuery({
    params: { projectId: Number(project_Id) },
  });

  // console.log("data:", vendorPaymentCheckData?.data?.exists);

  const projectRole = localStorage.getItem("project_role");

  const isSuperAdmin = keycloak?.realmAccess?.roles?.includes("super_admin");

  const productLogo = localStorage.getItem("product_logo");

  const productName = localStorage.getItem("product_name");

  // console.log("productName :", productName);

  function getItem(
    label: ReactNode,
    path: string,
    icon?: ReactNode,
    badge?: string,
    children?: MenuItem[],
    roles?: string[]
  ): MenuItem {
    return {
      key: pathString(path),
      icon,
      children,
      label: children?.length ? (
        label
      ) : (
        <Link to={path}>
          {label}
          {badge && !collapsed ? (
            <button className="text-secondary text-xs font-medium uppercase px-2 py-0.5 bg-white rounded border border-secondary h-6 justify-center items-center inline-flex ml-1.5">
              beta
            </button>
          ) : undefined}
        </Link>
      ),
      roles,
    } as MenuItem;
  }

  // const roleSidebar = AllSidebarMenu.map((item) => {
  //   if (item?.path === "/admin/businesses") {
  //     return {
  //       ...item,
  //       role: (isSuperAdmin ? ["SUPER_ADMIN"] : item?.role) as Role[],
  //     };
  //   }

  //   if (item?.children?.length) {
  //     return item?.children?.map((val) => {
  //       if (val?.path === "/admin/businesses/business-list") {
  //         return {
  //           ...item,
  //           role: (isSuperAdmin ? ["SUPER_ADMIN"] : item?.role) as Role[],
  //         };
  //       }

  //       return val;
  //     });
  //   }

  //   return item;
  // });

  // filter allowed menu

  const BSRM_USER = localStorage.getItem("BSRM_USER");

  const CASH_USER = localStorage.getItem("CASH_USER");

  const menu =
    BSRM_USER === "BSRM_USER"
      ? BsrmSidebarMenu
      : BSRM_USER === "CASH_USER"
      ? CashCollectionSidebarMenu
      : AllSidebarMenu;
  const MenuItems: MenuItem[] = menu
    .filter((el) => {
      if (!el?.role?.length) {
        return true;
      }

      // if (
      //   el?.name === "Vendor Payment" &&
      //   !vendorPaymentCheckData?.data?.exists
      // ) {
      //   return false;
      // }

      // console.log("el?.name:", el?.name);

      // console.log(
      //   "disbursementCheckData?.data?.exists",
      //   disbursementCheckData?.data?.exists
      // );

      if (el?.name === "Disbursement" && !disbursementCheckData?.data?.exists) {
        return false;
      }

      // console.log("Success response");

      if (productName && el?.name === "Users Role Access") {
        return false;
      }

      if (productName && el?.name === "Settings") {
        return false;
      }

      // console.log("el?.role:", el?.role);
      // console.log("role:", role);
      // console.log("BSRM_USER:", BSRM_USER);
      // console.log("projectRole:", projectRole);

      return el?.role?.find(
        (rl) =>
          rl === role ||
          rl === BSRM_USER ||
          rl === projectRole?.toLocaleLowerCase()
      );
    })
    .map(({ name, path, icon: Icon, children, badge }) =>
      getItem(
        name,
        path,
        Icon ? <Icon /> : undefined,
        badge,
        children?.length
          ? children
              .filter((el) => {
                if (!el?.role?.length) {
                  return true;
                }
                return el?.role?.find(
                  (rl) =>
                    rl === role ||
                    rl === BSRM_USER ||
                    rl === projectRole?.toLocaleLowerCase()
                );
              })
              .map(
                ({
                  name: cdName,
                  path: cdPath,
                  icon: CDIcon,
                  badge: cdBadge,
                }) =>
                  getItem(
                    cdName,
                    cdPath,
                    CDIcon ? <CDIcon /> : undefined,
                    cdBadge
                  )
              )
          : undefined
      )
    );

  // TODO: sidebar without role
  // const MenuItems: MenuItem[] = AllSidebarMenu.map(
  //   ({ name, path, icon: Icon, children, badge }) =>
  //     getItem(
  //       name,
  //       path,
  //       Icon ? <Icon /> : undefined,
  //       badge,
  //       children?.length
  //         ? children.map(
  //             ({ name: cdName, path: cdPath, icon: CDIcon, badge: cdBadge }) =>
  //               getItem(
  //                 cdName,
  //                 cdPath,
  //                 CDIcon ? <CDIcon /> : undefined,
  //                 cdBadge
  //               )
  //           )
  //         : undefined
  //     )
  // );

  // find active sub menu
  function getActiveMenu(data: any[]) {
    const strArr = stringToArray(location.pathname, "/");
    return data?.find((el) => el?.key === strArr[1])?.children ? true : false;
  }

  return (
    <div
      className={`sticky !bg-white z-50 ${"top-0 h-screen"}`}
      // className={`sticky !bg-white z-50 ${
      //   !user?.data?.email_verified && !isMobile
      //     ? "top-12 h-[calc(100vh-3rem)]"
      //     : "top-0 h-screen"
      // }`}
    >
      <Sider trigger={null} collapsible collapsed={collapsed} width={312}>
        <div className={`   bg-white`}>
          <div
            className={`flex h-[81px] items-center  ${
              collapsed ? "h-[4rem]" : "h-[6rem]"
            }`}
          >
            <div className="w-full flex justify-center items-center mt-4">
              <Link to="/admin/dashboard">
                {productLogo ? (
                  <div className="inline-flex items-center gap-2">
                    <Image
                      src={productLogo}
                      alt={APP_NAME}
                      width={collapsed ? 40 : 60}
                      height={collapsed ? 40 : 60}
                      className={collapsed ? "rounded" : ""}
                    />
                    {collapsed ? (
                      ""
                    ) : (
                      <span className="text-base font-medium leading-none !text-[#343A40]">
                        {productName}
                      </span>
                    )}
                  </div>
                ) : (
                  <Image
                    width={collapsed ? 40 : 80}
                    src={collapsed ? "/favicon.png" : MainLogo}
                    className={collapsed ? "!rounded" : ""}
                    alt={APP_NAME}
                  />
                )}
              </Link>
            </div>
          </div>
          <div
            className={`flex items-center bg-white px-4 pb-1.5 ${
              collapsed ? "gap-1" : "gap-4"
            }`}
          >
            <h2
              className={`text-display-medium text-xs font-semibold tracking-tight ${
                collapsed && "text-center"
              }`}
            >
              MENU
            </h2>
            {<div className="flex-1 border-b border-display-light" />}
          </div>

          {/* sidebar item section */}
          <div
            className={`!overflow-auto bg-white sticky custom-scrollbar ${
              !isMobile ? "h-[calc(100vh-9.3rem)]" : "h-[calc(100vh-6rem)] pt-1"
            }`}
            // className={`!overflow-auto bg-white sticky custom-scrollbar ${
            //   !user?.data?.email_verified && !isMobile
            //     ? "h-[calc(100vh-9.3rem)]"
            //     : "h-[calc(100vh-6rem)] pt-1"
            // }`}
          >
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={[
                activePathString(
                  location.pathname,
                  "/",
                  getActiveMenu(MenuItems)
                ),
              ]}
              openKeys={openMenuKeys}
              onOpenChange={handleOpenMenu}
              items={MenuItems}
              className={`!bg-white !px-4 !select-none ${
                collapsed ? "px-3" : ""
              }`}
              rootClassName="custom-sidebar"
              expandIcon={({ isSubMenu, isOpen }) => {
                if (isSubMenu && !collapsed) {
                  return isOpen ? <UpArrow /> : <DownArrow />;
                }
              }}
            />
          </div>
        </div>
      </Sider>
    </div>
  );
}

const activePathString = (
  path: string,
  splitText: string,
  isSubMenu?: boolean
) => {
  const pathArray = stringToArray(path, splitText);
  return pathArray.slice(1, (isSubMenu ? 3 : 2) - 0).join("/");
};

const pathString = (path: string, splitText: string = "/") => {
  return stringToArray(path, splitText).slice(1, 3).join("/");
};
